/* eslint-disable */
import KeenSlider from 'keen-slider';


/**
 * Keen Slider Module - Main 
 * Docs : https://keen-slider.io/docs
 *
 * Other instances of Keen Slider found in:
 *   initDyanmicResouceCenter.js
 *   initStatsBlock.js
 *   iniTabbedResourceCarousel.js
 *   initTeamGridCarousel.js
 */
export default function initSliderMod() {

    const slidersElements = document.querySelectorAll('.keen-slider');
    const mobileSliderElements = document.querySelectorAll('.slider-mobile-only, .mobile-only-slider');

    const AccesibilityPlugin = (slider) => {

        const slides = slider.slides;

        const onMove = (e) => {
            const slidesData = slider.track.details.slides;
            for (let i = 0; i < slides.length; i++) {
                slides[i].setAttribute('aria-hidden', false);
            }
        };

        const onRest = (e) => {
            const slidesData = slider.track.details.slides;
    
            for (let i = 0; i < slides.length; i++) {
                const slideData = slidesData[i];
                slides[i].setAttribute('aria-hidden', (slideData.portion === 0 ));
            }
        }
        
        slider.on('created' , ()=> { 
            setTimeout( onRest , 200 );

            for (let i = 0; i < slides.length; i++) {
                
                slides[i].addEventListener('focusin', (e) => {
                    if (e.target.matches(':focus-visible')) {
                        slider.moveToIdx(i);
                    } 
                    // move keen slider to this slide
                    //slider.moveToSlide(i);
                });
                
            } 
        });
        slider.on('slideChanged', onRest );
        slider.on('dragStart', onMove );
        slider.on('animationStarted', onMove );
        slider.on('animationEnded', onRest);
       // slider.on('updated', {} );
        
    };

    const WheelControlsPlugin = (slider) => {
        
        let touchTimeout, position, wheelActive;

        const dispatch = (e, name) => {
            position.x -= e.deltaX;
            position.y -= e.deltaY;
            slider.container.dispatchEvent(new CustomEvent(name, { detail: { x: position.x, y: position.y } }));
        };

        const wheelStart = (e) => {
            position = { x: e.pageX, y: e.pageY };
            dispatch(e, "ksDragStart");
        };

        const wheel = (e) => dispatch(e, "ksDrag");
        const wheelEnd = (e) => dispatch(e, "ksDragEnd");

        const eventWheel = (e) => {
            if (e.deltaX === 0) return false;

            e.preventDefault();
            if (!wheelActive) {
                wheelStart(e);
                wheelActive = true;
            }
            wheel(e);
            clearTimeout(touchTimeout);
            touchTimeout = setTimeout(() => {
                wheelActive = false;
                wheelEnd(e);
            }, 50);
        };

        slider.on("created", () => {
            slider.container.addEventListener("wheel", eventWheel, { passive: false });
        });
    };

    const initKeenSliders = () => {
        // loop through slider divs
        slidersElements.forEach(( sliderElm ) => {
            console.log('[init slider] ' );
            const container = sliderElm.querySelector('.slider-container');
			if( !container ) return;
            const canLoop = (sliderElm.dataset.loop === 'true' || sliderElm.dataset.loop === 'TRUE');
            const canLoopMobile = (sliderElm.dataset.loop === 'true' || sliderElm.dataset.loop === 'TRUE' || sliderElm.dataset.loop === 'mobile');
            const duration = sliderElm.dataset.animationDuration || 1000;
            const animateOnIteratorClick = sliderElm.dataset.indicatorClick === "animated" || false;
            const allowDrag = sliderElm.dataset.allowDrag === "true" || false;
            const allowDragMobile = sliderElm.dataset.allowDrag === "true" || sliderElm.dataset.allowDrag === "mobile" || false;
            const rubberband = sliderElm.dataset.rubberband === "true" || false;
            const isCentered = (sliderElm.dataset.centered === "true" || sliderElm.dataset.centered === "TRUE" ) || false;
            const autoplayInteractStop = (sliderElm.dataset.autoplayInteractStop === "true" || sliderElm.dataset.autoplayInteractStop === "TRUE" ) || false;
            const animationType = sliderElm.dataset.animationType || 'scroll';
            const normalize = sliderElm.dataset.normalize || 'none';
            const autoHideNav = sliderElm.dataset.autoHideNav === "true"  || false;
            
            let autoplay = sliderElm.dataset.autoplay || 0;
            let rendermode = sliderElm.dataset.rendermode || 'precision';

            let spaceBetween = (sliderElm.dataset.spacing && sliderElm.dataset.spacing.split(',')) || (sliderElm.dataset.spacebetween && sliderElm.dataset.spacebetween.split(',')) || (sliderElm.dataset.spacing && sliderElm.dataset.spacing.split(',')) || [0,0,0,0,0];
            let slidesPerView = (sliderElm.dataset.slidesPerView && sliderElm.dataset.slidesPerView.split(',')) || (sliderElm.dataset.perView && sliderElm.dataset.perView.split(',')) || [1,1,1,1,1];
            let controlsContainer = sliderElm.querySelector('.slider__controls');
            let navBtns = sliderElm.querySelectorAll('.slider-nav');
            let navBtnContainer = sliderElm.querySelector('.cards-slider__buttons');
            let indicators = sliderElm.querySelector('.slider-indicators');
            let secondaryIndicators = sliderElm.querySelector('.secondary-indicators');

            if( navBtns.length === 0 ) {
                navBtns = sliderElm.querySelectorAll('.carousel-nav');
            }

            if( !navBtnContainer) {
                navBtnContainer = sliderElm.querySelector('.carousel-controls');
            }

            if (!indicators) {
                indicators = sliderElm.querySelector('.carousel-controls-indicators');
            }

            if(slidesPerView.length < 5) {
                // fill in the rest of the array with the last value
                let lastValue = slidesPerView[slidesPerView.length - 1];
                for (let i = slidesPerView.length; i < 5; i++) {
                    slidesPerView.push(lastValue);
                }
            }

            if(spaceBetween.length < 5) {
                // fill in the rest of the array with the last value
                let lastValue = spaceBetween[spaceBetween.length - 1];
                for (let i = spaceBetween.length; i < 5; i++) {
                    spaceBetween.push(lastValue);
                }
            }

            // add classes to slider container and children
            container.classList.add('keen-slider-container');

            const children = container.children;
            for (let i = 0; i < children.length; i++) {
                children[i].classList.add('keen-slider__slide');

                if (normalize === 'height') {
                    children[i].classList.add('match-height');
                } else if (normalize === 'width') {
                    children[i].classList.add('match-width');
                } else if (normalize === 'both') {
                    children[i].classList.add('match-both');
                }
            }

            if( navBtns.length ) {
                sliderElm.classList.add('slider-nav-visible');
                if (!canLoop) {
                    sliderElm.classList.add('slider-nav-autohide');
                    sliderElm.classList.add('slider-item-first-visible');
                }
            }

            if (animationType === 'fade') {
                rendermode = 'custom';
                sliderElm.classList.add('keen-slider-custom');

                let h = 0;
                for (let i = 0; i < children.length; i++) {
                    if( children[i].clientHeight > h ) h = children[i].clientHeight;
                }
                container.style.height = h + 'px';
            }
            

            const sliderOptions = {
                defaultAnimation: {
                    duration: duration,
                },
                slides: {
                    origin: 'auto',
                    spacing: spaceBetween[0],
                    perView: slidesPerView[0]
                },
                drag: allowDrag,
                loop: canLoop,
                renderMode: rendermode,
                rubberband: rubberband,
                centered: false,
                breakpoints: {
                    '(min-width: 576px)': {
                        drag: allowDragMobile,
                        loop: canLoopMobile,
                        slides: { perView: slidesPerView[0] , spacing: spaceBetween[0] }
                    },
                    '(min-width: 768px)': {
                        centered: true,
                        slides: { perView: slidesPerView[1], spacing: spaceBetween[1] }
                    },
                    '(min-width: 992px)': {
                        slides: { perView: slidesPerView[2], spacing: spaceBetween[2] }
                    },
                    '(min-width: 1200px)': {
                        slides: { perView: slidesPerView[3], spacing: spaceBetween[3] }
                    },
                    '(min-width: 1400px)': {
                        slides: { perView: slidesPerView[4], spacing: spaceBetween[4] }
                    },
                },
                detailsChanged: (s) => {
                    if (animationType === 'fade') {
                        //console.log('animationType fade');
                        s.slides.forEach((element, idx) => {
                            element.style.opacity = s.track.details.slides[idx].portion
                        })
                    }
                },
            };

            const keenSlider = new KeenSlider( container,
                sliderOptions ,
                [
                    /*** auto play plugin */
                    (slider) => {
                        if( autoplay == 0 ) return;

                        let timeout
                        let mouseOver = false
                        function clearNextTimeout() {
                            clearTimeout(timeout)
                        }
                        function nextTimeout( s ) {
                            clearTimeout(timeout)
                            if (mouseOver) return
                            if (autoplay == 0) return;
                            timeout = setTimeout(() => {
                                if( autoplay == 0 ) return;
                                slider.next()
                            }, autoplay )
                        }
                        slider.on("created", () => {
                            slider.container.addEventListener("mouseover", () => {
                                mouseOver = true
                                clearNextTimeout()
                            })
                            slider.container.addEventListener("mouseout", () => {
                                mouseOver = false
                                nextTimeout()
                            })
                            nextTimeout()
                        })
                        slider.on("dragStarted", clearNextTimeout)
                        slider.on("animationEnded", nextTimeout)
                        slider.on("updated", nextTimeout)

                    }, WheelControlsPlugin, AccesibilityPlugin
                ]
            );


            /*** indicators */
            if (indicators) {
                const indicatorChildren = indicators.children;

                for (let i = 0; i < indicatorChildren.length; i++) {
                    const indicator = indicatorChildren[i];
                    //console.log( 'indicator', indicator );
                    indicator.addEventListener('click', ( e ) => {
                        //console.log( 'clicked' , e );
                        if (autoplayInteractStop) autoplay = 0;
                        keenSlider.moveToIdx(i, false, { duration: (animateOnIteratorClick) ? duration : 0 } );
                    });
					indicator.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
							if (autoplayInteractStop) autoplay = 0;
							keenSlider.moveToIdx(i, false, { duration: (animateOnIteratorClick) ? duration : 0 } );
                        }
                    });
                }

                keenSlider.on('slideChanged', (s) => {
                    const child = indicatorChildren[keenSlider.track.details.rel];
                    //console.log( indicatorChildren );
                    for (let i = 0; i < indicatorChildren.length; i++) {
                        indicatorChildren[i].classList.remove('active');
						indicatorChildren[i].setAttribute('aria-selected', false);

                    }
                    if( child ){
						child.classList.add('active');
						child.setAttribute('aria-selected', true);
					}
                });
            }


            if (secondaryIndicators ) {
                const indicatorChildren = secondaryIndicators.children;

                for (let i = 0; i < indicatorChildren.length; i++) {
                    const indicator = indicatorChildren[i];
                // console.log('indicator', indicator);
                    indicator.addEventListener('click', (e) => {
                        //console.log('clicked', e);
                        if (autoplayInteractStop) autoplay = 0;
                        keenSlider.moveToIdx(i, false, { duration: (animateOnIteratorClick) ? duration : 0 });
                    });
					indicator.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
							if (autoplayInteractStop) autoplay = 0;
							keenSlider.moveToIdx(i, false, { duration: (animateOnIteratorClick) ? duration : 0 });
						}
                    });
                }

                keenSlider.on('slideChanged', (s) => {
                    const child = indicatorChildren[keenSlider.track.details.rel];
                    //console.log(indicatorChildren);
                    for (let i = 0; i < indicatorChildren.length; i++) {
                        indicatorChildren[i].classList.remove('active');
						indicatorChildren[i].setAttribute('aria-selected', false);
                    }
                    child.classList.add('active');
					child.setAttribute('aria-selected', true);
                });
            }

            /*** nav buttons */
            if (navBtns.length) {
                //console.log( 'has nav buttons' );
                navBtns.forEach((btn) => {
                    if (btn.classList.contains('slider-nav-next') || btn.classList.contains('carousel-nav-next')) {
                        btn.addEventListener('click', () => {
                            //console.log('next');
                            keenSlider.next();
                            if (autoplayInteractStop) autoplay = 0;
                        });
                    } else {
                        btn.addEventListener('click', () => {
                            //console.log( 'prev' );
                            keenSlider.prev();
                            //console.log(keenSlider );
                            if (autoplayInteractStop) autoplay = 0;
                        });
                    }
                });

                keenSlider.on('slideChanged', (e) => {

                    if (keenSlider.track.details.rel === 0) {
                        sliderElm.classList.add('slider-item-first-visible');
                    } else {
                        sliderElm.classList.remove('slider-item-first-visible');
                    }

                    if (keenSlider.track.details.rel === keenSlider.track.details.maxIdx) {
                        sliderElm.classList.add('slider-item-last-visible');
                    } else {
                        sliderElm.classList.remove('slider-item-last-visible');
                    }
                });
            }


            if (autoHideNav && keenSlider.track.details.length === 0) {
                controlsContainer.style.display = 'none';
            }

            keenSlider.nav = controlsContainer;
            window.addEventListener('resize', () => { onVideoResize(keenSlider); });
            onVideoResize(keenSlider);

            if (keenSlider) sliderElm.classList.add( 'keen-inited' );

        }); // sliders forEach
    }

    const initMobileOnlySliders = () => {
       
        mobileSliderElements.forEach((originalElm) => {
    
            const perView = originalElm.dataset.perView || 1;
            const spacing = originalElm.dataset.spacing || 0;
            // duplicate slider for mobile & nest in container
            const mobileSlider = originalElm.cloneNode(true);
            const mobileContainer = document.createElement('div');
            mobileContainer.classList.add('d-lg-none');
            mobileContainer.classList.add('mobile-slider-container');
            mobileContainer.appendChild(mobileSlider);
            originalElm.parentNode.appendChild(mobileContainer);

            // nest original element in responsive container
            const elmContainer = document.createElement('div');
            elmContainer.classList.add('d-none');
            elmContainer.classList.add('d-lg-block');
            elmContainer.classList.add('desktop-nonslider-container');
            elmContainer.appendChild(originalElm);
            originalElm.classList.remove('slider-mobile-only', 'mobile-only-slider');
            mobileContainer.parentNode.appendChild(elmContainer);

            // add nav if .slider-add-nav is present //
            if (mobileSlider.classList.contains('slider-add-nav')) {
                const navContainer = document.createElement('div');
                navContainer.classList.add('slider-nav-container');
                navContainer.innerHTML = `
                    <button type="button" class="slider-nav slider-nav-prev"><span class="visually-hidden">Previous slide</span></button>
                    <button type="button" class="slider-nav slider-nav-next"><span class="visually-hidden">Next slide</span></button>
                `;
                mobileContainer.appendChild(navContainer);
            }

            for (let i = 0; i < mobileSlider.children.length; i++) {
                mobileSlider.children[i].classList.add('slide');
            }

            const sliderComponent = new KeenSlider(mobileSlider,
                {
                    selector: [...mobileSlider.children],
                    defaultAnimation: {
                        duration: 1000,
                    },
                    slides: {
                        origin: 'auto',
                        perView: perView,
                        spacing: spacing,
                    },
                    drag: true,
                    loop: mobileSlider.classList.contains('slider-loop'),
                    renderMode: 'precision',
                    rubberband: mobileSlider.classList.contains('slider-rubberband'),
                    centered: mobileSlider.classList.contains('slider-centered'),
                    
                },
                [WheelControlsPlugin , AccesibilityPlugin]
            );
			let navBtns = mobileContainer.querySelectorAll('.slider-nav');

			navBtns.forEach((btn) => {
				if (btn.classList.contains('slider-nav-next') || btn.classList.contains('carousel-nav-next')) {
					btn.addEventListener('click', () => {
						//console.log('next');
						sliderComponent.next();
					});
				} else {
					btn.addEventListener('click', () => {
						//console.log( 'prev' );
						sliderComponent.prev();
					});
				}
			});


        });
    }

    const onVideoResize = (keenSlider ) => {
        if (keenSlider.nav) keenSlider.nav.style.display = (keenSlider.track.details?.length == 0) ? 'none' : 'flex';
    }

    /** init */
    const init = () => {
        if (mobileSliderElements.length > 0) initMobileOnlySliders();
        if (slidersElements.length > 0) initKeenSliders();
    }

    init();
}
